export default __webpack_public_path__ + "static/media/book.9ea1d764.svg";